const SET_SGIP_VALUE = 'SET_SGIP_VALUE';
const SET_SGIP_TOGGLE = 'SET_SGIP_TOGGLE';

export {
    SET_SGIP_VALUE,
    SET_SGIP_TOGGLE,
};



// WEBPACK FOOTER //
// ./src/containers/common/sgip/constants.js